<template>
	<page>
		<module>
			<view-list :work-type="workType" ref="view" selector :view-config="auth('b_order_product_viewmanage')">
				<template #search>
					<m-search ref="search">
						<m-search-item label="订单号">
							<c-input name="order_code"></c-input>
						</m-search-item>
						<m-search-item label="客户">
							<c-select name="customer_ids" async multiple @search="searchCustomer"></c-select>
						</m-search-item>
						<m-search-item label="产品信息">
							<c-input name="product_info" placeholder="支持产品编号/名称/规格"></c-input>
						</m-search-item>
						<m-search-item label="订单状态">
							<c-select name="order_states" :options="salesOrderStateDic" multiple></c-select>
						</m-search-item>
						<m-search-item label="要求交货时间" colspan="2">
							<c-datetime range start-name="plan_delivery_start_date" end-name="plan_delivery_end_date"></c-datetime>
						</m-search-item>
						<m-search-item label="创建时间" colspan="2">
							<c-datetime range start-name="start_date" end-name="end_date"></c-datetime>
						</m-search-item>
					</m-search>
				</template>

				<template #operate>
					<c-button v-if="auth('b_order_product_export')" v-lock="lock('b_order_product_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
					<c-button v-if="auth('b_order_product_export')" v-lock="lock('b_order_product_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId(3)">按模板导出</c-button>
                </template>

				<template #batchOperate="{data}">
					<c-button v-if="auth('b_order_product_transfer')" v-lock="lock('b_order_product_transfer')" prepend-icon="tf-order" @click="transferWork(data)">转工单</c-button>
					<c-button v-if="auth('b_order_product_transfer_assemble')" v-lock="lock('b_order_product_transfer_assemble')" prepend-icon="tf-order-trans" @click="transferAssemble(data)">转装配工单</c-button>
					<c-button v-if="auth('b_order_product_export')" v-lock="lock('b_order_product_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
					<c-button v-if="auth('b_order_product_export')" v-lock="lock('b_order_product_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId(3)">按模板导出</c-button>
					<c-button v-if="auth('b_order_product_print')" v-lock="lock('b_order_product_print')" prepend-icon="tf-print" @click="$refs.view.batchExportByTemplate()">打印</c-button>
				</template>

				<template #order_code="{data}">
					<c-link @click="globalDialog('orderDetail', {props: {id: data.order_id}})">{{data.order_code}}</c-link>
				</template>

				<!--完成时间-->
				<template #finish_date="{data}">
					<span v-if="data.order_state == 3">{{data.finish_date}}</span>
					<span v-else>-</span>
				</template>

				<!--产品单价-->
				<template #product_price="{data}">
					￥{{data.product_price}}
				</template>

				<!--产品金额-->
				<template #product_money="{data}">
					￥{{data.product_money}}
				</template>
				
				<!--产品来源-->
				<template #product_source="{data}">
					<c-state dict="productSourceName" :value="data.product_source"></c-state>
				</template>
				
				<!--产品类型-->
				<template #product_type="{data}">
					<c-state dict="productTypeName" :value="data.product_type"></c-state>
				</template>

				<!--订单状态-->
				<template #order_state="{data}">
					<c-state dict="salesOrderStateDic" tag :value="data.order_state"></c-state>
				</template>
				
				<!--交货进度%-->
				<template #deliver_progress="{data}">
					<c-progress :rate="[data.deliver_count, data.main_product_count]" :color="((data.deliver_count/data.main_product_count)>=1||data.deliver_count==0) ?'green':'blue'"></c-progress>
				</template>
				
				<!--逾期状态-->
				<template #plan_date_state="{data}">
					<c-state type="expectedDate" :value="data.expected_date"></c-state>
				</template>
				
				<!--生产进度%-->
				<template #work_detail_progress="{data}">
					<c-progress v-if="data.scheduling_count > 0" :rate="[data.task_fine_count, data.task_plan_count||1]" :color="((data.task_fine_count/data.task_plan_count)>=1||data.task_plan_count==0) ?'green':'blue'"></c-progress>
					<span v-else>-</span>
				</template>

				<c-table-column
					type="button"
					label="操作"
					width="205"
					button-limit="3"
				>
					<template #default="{data}">
						<c-table-button v-if="auth('b_order_product_print')" v-lock="lock('b_order_product_print')" icon="tf-print" @click="$refs.view.exportByTemplate(data.id)">打印</c-table-button>
						<c-table-button v-if="auth('b_order_product_transfer')" v-lock="lock('b_order_product_transfer')" :disabled="!(data.order_state == 2)" icon="tf-order" @click="transferWork([data])">转工单</c-table-button>
						<c-table-button v-if="auth('b_order_product_transfer_assemble')" v-lock="lock('b_order_product_transfer_assemble')" :disabled="!(data.order_state == 2)" icon="tf-order-trans" @click="transferAssemble([data])">转装配工单</c-table-button>
					</template>
				</c-table-column>
			</view-list>
		</module>
	</page>
</template>

<script>
	import {mapState} from 'vuex'

	export default {
		components: {
			
		},
		
		data() {
			return {
                workType: 41
			}
		},

		computed: {
			// 获取dictName选项数据
			...mapState(['salesOrderStateDic'])
		},
		
		methods: {
			/*******搜索【客户】下拉框信息*****************/
			searchCustomer(keyword, resolve){
				this.request({
					url:'/system/options',
					data: {
						options_code:'CUSTOMER',
						keyword:keyword
					},
					success:data => {
						resolve(data);
					}
				})
			},
			
			/******转工单******/
			transferWork(selectData) {
				//仅执行中的订单明细可转单
				if(selectData.some(item => item.order_state != 2)) {
					this.$message({
						message:'仅执行中的订单明细可转工单',  // 提示内容,
						type: 'error'
					});
					return;
				}
				//仅自产、外协产品可转工单
				const orderProduct = selectData.filter(item => item.product_source == 1 || item.product_source == 3).map(item => {
					return Object.assign({}, item, {
						order_product_id: item.id,
						unit_count: item.unit_count || 1,
						ref_type: 1
					});
				});
				if(orderProduct.length == 0) {
					this.$message({
						message:'没有可以转单的产品',  // 提示内容,
						type: 'error'
					});
					return;
				}
				
				this.globalDialog('batchWorkEdit', {
					data: {
						ref_type: 1,
						orderProductList: orderProduct
					}
				},
				()=>{
					this.$refs.view.refresh();
				});
			},
			
			/******转装配工单******/
			transferAssemble(selectData) {
				//仅执行中的订单明细可转单
				if(selectData.some(item => item.order_state != 2)) {
					this.$message({
						message:'仅执行中的订单明细可转装配工单',  // 提示内容,
						type: 'error'
					});
					return;
				}
				//装配工单仅支持单一订单转换
				const orderIds = [];
				selectData.forEach(item => {
					if(orderIds.indexOf(item.order_id) == -1) {
						orderIds.push(item.order_id);
					}
				});
				if(orderIds.length > 1) {
					this.$message({
						message:'转装配工单仅支持同一销售订单的明细',  // 提示内容,
						type: 'error'
					});
					return;
				}
				//选中的订单明细ID
				const selectIds = selectData.map(item => item.id);
				
				this.request({
					url: '/order/productBom',
					data: {
						product_source: [1],		//只查询自产产品
						order_ids: orderIds
					},
					success: data => {
						if(data != null && data.length > 0 && data[0].childProduct != null && data[0].childProduct.length > 0){
							//仅保留选中的订单明细，且仅自产、外协产品可转单
							const orderProduct = data[0].childProduct.filter(item => selectIds.indexOf(item.id) > -1 && (item.product_source == 1 || item.product_source == 3)).map(item => {
								return Object.assign({}, item, {
									order_product_id: item.id,
									unit_count: item.unit_count || 1,
									ref_type: 1
								});
							});
							if(orderProduct.length == 0) {
								this.$message({
									message:'没有可以转单的产品',  // 提示内容,
									type: 'error'
								});
								return;
							}
							this.globalDialog('assembleEdit', {
								props: {
									ref_type: 1,
									ref_id: orderIds[0],
									orderProductList: orderProduct
								}
							},
							()=>{
								this.$refs.view.refresh();
							});
						}else{
							this.$message({
								message:'没有可以转单的产品',  // 提示内容,
								type: 'error'
							});
						}
					}
				})
			},
		}
	}
</script>

<style lang="stylus" scoped>
</style>